/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2023] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetApprovedCommandsByExternalUserID(id) {
  const response = await $.soap({
    body: {
        GetApprovedCommandsByExternalUserID: {
        $xmlns: 'http://dla.mil/ems/db/user/external_user_command',
        ExternalUserID: id
      }
    },
    blueprintArrays: ['GetApprovedCommandsByExternalUserIDResponse.tuple'],
    blueprint: {
      commands: [
        '$..GetApprovedCommandsByExternalUserIDResponse.tuple',
        {
          id: '$.old.ExternalUserCommand.CommandID',
          name: '$.old.ExternalUserCommand.CommandName',
          serviceBranchID: '$.old.ExternalUserCommand.ServiceBranchID',
          serviceBranchName: '$.old.ExternalUserCommand.ServiceBranchName',
          regionName: '$.old.ExternalUserCommand.RegionName',
          dodac: '$.old.ExternalUserCommand.DODAC',
          status: '$.old.ExternalUserCommand.Status',
          requestedOn: '$.old.ExternalUserCommand.RequestedOn',
          decidedOn: '$.old.ExternalUserCommand.DecidedOn'
        }
      ]
    }
  });

  cleanUpResponse(response);
  return response.commands;
}
